module.exports = __webpack_public_path__ + "static/media/minus.4f218d5b.png";